// Products
import ButterfliesCatch from './img/common/Butterflies-catch.svg';
// Common
import Butterflies from './img/common/Butterflies.svg';
import Consent from './img/common/Consent.svg';
import Heart from './img/common/Heart.svg';
import Refinancing from './img/common/Refinancing.svg';
import Stop from './img/common/Stop.svg';
import Wallet from './img/common/Wallet.svg';
import CreditCard from './img/products/CreditCard.svg';

export type Assets =
    | 'CreditCard'
    | 'Butterflies'
    | 'ButterfliesCatch'
    | 'Consent'
    | 'Heart'
    | 'Refinancing'
    | 'Stop'
    | 'Wallet';

export const assetList = {
    CreditCard,
    Butterflies,
    ButterfliesCatch,
    Consent,
    Heart,
    Refinancing,
    Stop,
    Wallet,
};

export const getAssetByName = (asset: Assets) => assetList[asset];
